import { styled } from '@mui/material';

export const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main
}));
